import { useSelector } from 'react-redux'
import { useCurrentCloudProvider } from '@labrav/common'

import type {
  CloudMarketplace,
  Product,
} from '../../../modules/productsListing/types'

type FlyOutProductsRootState = {
  productsListing: Partial<
    Record<
      CloudMarketplace,
      {
        products?: { rows?: Product[] }
        productsV2?: { rows?: Product[] }
        selectedProduct?: string
        freeTierInfo?: { additionalAllowedProducts?: number }
      }
    >
  >
  privateOffers?: {
    freeTierInfo?: { additionalAllowedPrivateOffers?: number }
  }
  AccountData?: {
    user?: {
      partnerData?: {
        subscribedProducts?: {
          FLYOUT?: { plan?: string }
        }
      }
    }
  }
}

export const useFlyOutProductsBasedOnSelectedCloud = (
  flags: Record<string, boolean> = { microsoftResellerAuthorization: false }
) => {
  const selectedCloudMarketplace = useCurrentCloudProvider(flags)
  const products = useSelector((state: FlyOutProductsRootState) => {
    const rows =
      state.productsListing?.[selectedCloudMarketplace]?.products?.rows
    return Array.isArray(rows) ? rows : []
  })
  const productsV2 = useSelector((state: FlyOutProductsRootState) => {
    const rows =
      state.productsListing?.[selectedCloudMarketplace]?.productsV2?.rows
    return Array.isArray(rows) ? rows : []
  })
  const selectedProduct = useSelector(
    (state: FlyOutProductsRootState) =>
      state.productsListing?.[selectedCloudMarketplace]?.selectedProduct
  )
  const additionalAllowedProducts = useSelector(
    (state: FlyOutProductsRootState) =>
      state.productsListing?.[selectedCloudMarketplace]?.freeTierInfo
        ?.additionalAllowedProducts
  )
  const additionalAllowedPrivateOffers = useSelector(
    (state: FlyOutProductsRootState) =>
      state.privateOffers?.freeTierInfo?.additionalAllowedPrivateOffers
  )
  const plan = useSelector(
    (state: FlyOutProductsRootState) =>
      state.AccountData?.user?.partnerData?.subscribedProducts?.FLYOUT?.plan
  )

  return {
    products,
    productsV2,
    selectedProduct,
    additionalAllowedProducts,
    additionalAllowedPrivateOffers,
    plan,
  }
}
